module.exports = __webpack_public_path__ + "img/tomoyuki.e3b07b31.png";